/* eslint-disable complexity */
import { RUPEE_SYMBOL } from '@/root/constants'

export default function formatNumberToString(
  number: number,
  roundOff = true,
  decimalLength = 1,
  addRupeeSymbol = false,
) {
  const decimalLengthMultiplier = 10 ** decimalLength

  if (number) {
    let absNum = Math.abs(number)

    if (absNum < 1 && absNum > 0) {
      return addRupeeSymbol ? `₹${number.toFixed(2)}` : number.toFixed(2)
    }

    absNum = parseFloat(absNum.toString())
    const thousand = absNum / 1000
    const lakhs = absNum / 100000
    const crores = absNum / 10000000
    if (crores >= 1.0)
      return number < 0
        ? `-${addRupeeSymbol ? '₹' : ''}${
            Math.round(crores * decimalLengthMultiplier) /
            decimalLengthMultiplier
          }Cr`
        : `${addRupeeSymbol ? '₹' : ''}${
            Math.round(crores * decimalLengthMultiplier) /
            decimalLengthMultiplier
          }Cr`
    else if (lakhs >= 1.0)
      return number < 0
        ? `-${addRupeeSymbol ? '₹' : ''}${
            Math.round(lakhs * decimalLengthMultiplier) /
            decimalLengthMultiplier
          }L`
        : `${addRupeeSymbol ? '₹' : ''}${
            Math.round(lakhs * decimalLengthMultiplier) /
            decimalLengthMultiplier
          }L`
    else if (thousand >= 1.0)
      return number < 0
        ? `-${addRupeeSymbol ? '₹' : ''}${
            Math.round(thousand * decimalLengthMultiplier) /
            decimalLengthMultiplier
          }K`
        : `${addRupeeSymbol ? '₹' : ''}${
            Math.round(thousand * decimalLengthMultiplier) /
            decimalLengthMultiplier
          }K`
    else if (!roundOff) return addRupeeSymbol ? `₹${number}` : number
    else if (decimalLength > 1)
      return addRupeeSymbol
        ? `₹${Number(number.toFixed(decimalLength))}`
        : Number(number.toFixed(decimalLength))
    return addRupeeSymbol ? `₹${Math.round(number)}` : Math.round(number)
  } else {
    return 0
  }
}

export const formatNumberWithRupeeSymbolAndFixDecimals = ({
  value,
  decimalPlaces = 2,
}: {
  value?: number
  decimalPlaces?: number
}) => {
  return typeof value === 'number'
    ? `${RUPEE_SYMBOL}${value.toFixed(decimalPlaces)}`
    : undefined
}

export function formatNumberToINRCommaSeparatedString(
  num?: number,
  decimals = 2,
) {
  if (typeof num !== 'number') return ''
  return num.toLocaleString('en-IN', {
    maximumFractionDigits: decimals,
    style: 'currency',
    currency: 'INR',
  })
}

export function formatNumberToCommaSeparatedString(num?: number, decimals = 2) {
  if (typeof num !== 'number') return ''
  return num.toLocaleString('en-IN', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  })
}

export function formatNumberToUSDCommaSeparatedString(
  num?: number,
  withoutSymbol = false,
) {
  if (!num) return ''
  return num.toLocaleString('en-IN', {
    maximumFractionDigits: 2,
    style: withoutSymbol ? undefined : 'currency',
    currency: 'USD',
  })
}
